import { client } from './client';

const token = localStorage.getItem('user_token');

class mapLayerApi {
    static async all(limit = 10, offset = 0, activeOnly = false) {
        let response = await client.get('/map_layers/?limit=' + limit + '&offset=' + offset + '&active=' + activeOnly);
        return response.data;
    }

    static async getLayers(attrs) {
        let layers = attrs && attrs.layers ? attrs.layers : '',
            publicOnly = attrs && attrs.publicOnly;
        let response = await client.get('/map_layers/get?layers=' + layers + (publicOnly ? '&public=true' : ''));
        return response.data;
    }

    static async getAllowedForPartners() {
        let response = await client.get('/map_layers/allowed_for_partners');
        return response.data;
    }

    static async create(data) {
        let mapLayer = await client.put('/map_layers/', data);
        return mapLayer.data;
    }

    static async get(id) {
        let mapLayer = await client.get('/map_layers/' + id);
        return mapLayer.data;
    }

    static async update(mapLayer) {
        let result = await client.patch('/map_layers/' + mapLayer.id, mapLayer);
        return result.data;
    }

    static async delete(mapLayer) {
        let result = await client.delete('/map_layers/' + mapLayer.id);
        return result.data;
    }

    static async getCadastreByXY(x, y) {
        let formData = new FormData();
        const params = {
            f: 'json',
            _bearer: token,
            geometry: `${x}, ${y}`,
            geometryType: 'esriGeometryPoint',
            inSR: '3301',
            returnGeometry: 'false',
            tolerance: 0.0001,
            mapExtent: '538692.8618820332, 6589756.684567499, 548106.755709821, 6592241.127036384',
            layers: 'all',
            imageDisplay: '600,550,96'
        };
        for (const name in params) {
            formData.append(name, params[name]);
        }

        let result = await fetch(
            (window.location.port.length > 0 ? window.location.origin.replace(
                ':' + window.location.port, ''
            ) : window.location.origin) + '/proxy/layer/cadastre/identify',
            {
                method: 'POST',
                body: formData
            }
        );
        let returnValue;
        try {
            returnValue = result.json();
        } catch (e) {
            console.error("Cadastre x y problem!!!");
            returnValue = {};
        }
        return returnValue;
    }

    static async getObjectOwnerByXY(x, y, token) {
        let formData = new FormData();
        let response = null;
        const params = {
            f: 'json',
            _bearer: token,
            geometry: `${x}, ${y}`,
            geometryType: 'esriGeometryPoint',
            inSR: '3301',
            returnGeometry: 'false',
            returnFieldName: 'true',
            tolerance: 0.0001,
            mapExtent: '538692.8618820332, 6589756.684567499, 548106.755709821, 6592241.127036384',
            layers: 'all',
            imageDisplay: '600,550,96'
        };
        for (const name in params) {
            formData.append(name, params[name]);
        }
        try {
            return await fetch(
                (window.location.port.length > 0 ? window.location.origin.replace(
                    ':' + window.location.port, ''
                ) : window.location.origin) + '/proxy/layer/tkvr/identify',
                {
                    method: 'POST',
                    body: formData
                }
            ).then((json) => json.json()).catch(console.log);

        } catch (error) {
            console.log(error)
        }
        return response;
    }
}

export default mapLayerApi;
